<!-- prettier-ignore -->
<template>
  <transition name="router-anim">
    <div class="kits">      
      <!-- FBA Inventory Table -->
      <div class="form">
        <DescriptionModal class="description-modal" :description="'This page provides an overview of sales on Amazon and the Woo site. Use filters to view results for different timeframes.'" />
        <div class="filters">
            <!-- <h2>{{ message }}</h2> -->
            <!-- <div class="day-filter">
              <div
                class="title-filter"
                @click="show = !show"
                v-click-outside="closeModelList"
              >
                <img
                  class="title-down"
                  src="../../images/dashboard/down-blue.png"
                  alt="#"
                />
                <span class="drop-down-menu">{{ dayFilters[this.$store.getters.getDays] }}</span>
              </div>
              <transition>
                <FilterDays v-if="show"></FilterDays>
              </transition>
            </div> -->
            <div class="filter-wrap-custom">
              <select v-model="filters.month" class="input-sub-filter" @change="fetchSalesData">
                <option value="" >Select Filter</option>
                <option v-for="month in monthOptions" :key="month.value" :value="month.value">{{ month.text }}</option>
              </select>
            </div>
            <div class="filter-wrap-custom">
              <select v-model="filters.year" :class="disabled ? 'disabled input-sub-filter' : 'input-sub-filter'" @change="fetchSalesData" :disabled="disabled">
                <option value="" >Select Year</option>
                <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
            <div class="filter-wrap-btn" @click="reset">
              <button class="btn btn-test">Reset</button>
            </div>
        </div>

        <div class="chart-container" style="width: 100%;">
          <div class="chart-type-selector">
            <h2>Chart Type:</h2>
            <div class="input-wrap title_check sub-filter">
              <span class="radio-span">
                <input
                 id="sales-per"
                  type="radio"
                  name="chart_type"
                  value="pie"
                  v-model="chartType"
                /> <label for="sales-per">Sales Percentage</label>
              </span> 
              <span class="radio-span">
                <input
                  id="sales-history"
                  type="radio"
                  name="chart_type"
                  value="line"
                  v-model="chartType"
                /><label for="sales-history">Sales History</label> 
              </span>
            </div>
          </div>

          <div class="line-chart-wrap" v-if="chartType === 'line'">
            <div class="line">
              <v-chart :options="lineOptions" style="width: 100%; height: 400px;"></v-chart>
            </div>
          </div>

          <div class="pie-chart-container" v-if="chartType === 'pie'">
            <div class="pie-charts" v-if="showPieChart && chartType === 'pie'">
              <div class="total-pie">
                <v-chart :options="chartOptions.totalSales" style="width: 100%; height: 400px;"></v-chart>
              </div>
              <div class="amazon-pie">
                <v-chart :options="chartOptions.amazonSales" style="width: 100%; height: 400px;"></v-chart>
              </div>
              <div class="woo-pei">
                <v-chart :options="chartOptions.wooSales" style="width: 100%; height: 400px;"></v-chart>
              </div>
            </div>
          </div>
        </div>
        
        <div class="sales-data sales-data-woo p-20">
          <h1>Total Sales</h1>
          <table class="sales-table styled-table">
            <thead>
              <tr>
                <th class="title-data text-center"  @click="sortData('table1','type')">
                  Type 
                  <span v-if="sortParams.table1.sortKey === 'type'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table1.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th  @click="sortData('table1','product_name')">
                  Name 
                  <span v-if="sortParams.table1.sortKey === 'product_name'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table1.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-right" @click="sortData('table1','total_quantity')">
                  Quantity
                  <span v-if="sortParams.table1.sortKey === 'total_quantity'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table1.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-right" @click="sortData('table1','total_sales_amount')">
                  Product Price
                  <span v-if="sortParams.table1.sortKey === 'total_sales_amount'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table1.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sale in sortedTotalSalesData" :key="sale.id">
                <td class="text-center">{{ sale.type }}</td>
                <td >{{ sale.product_name }}</td>
                <td class="text-right">{{ sale.total_quantity }}</td>
                <td class="text-right">{{ formatPrice(sale.total_sales_amount) }}</td>
              </tr>
              <tr>
                <td class="text-center total"></td>
                <td></td>
                <td></td>
                <td class="text-right"><span class="total">Total</span> : {{ formatPrice(total_sales_price) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Amazon Sales Data Section -->
        <div class="sales-data p-20">
          <h1>Amazon Sales</h1>
          <table class="sales-table styled-table">
            <thead>
              <tr>
                <th class="title-data text-center" @click="sortData('table2','type')">
                  Type 
                  <span v-if="sortParams.table2.sortKey === 'type'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table1.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-center" @click="sortData('table2','year')">
                  Year 
                  <span v-if="sortParams.table2.sortKey === 'year'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table2.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-center" @click="sortData('table2','asin')">
                  ASIN 
                  <span v-if="sortParams.table2.sortKey === 'asin'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table2.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-center" @click="sortData('table2','unit_count')">
                  Unit Count 
                  <span v-if="sortParams.table2.sortKey === 'unit_count'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table2.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-center" @click="sortData('table2','order_count')">
                  Order Count 
                  <span v-if="sortParams.table2.sortKey === 'order_count'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table2.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-center" @click="sortData('table2','average_unit_price_amount')">
                  Average Unit Price 
                  <span v-if="sortParams.table2.sortKey === 'average_unit_price_amount'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table2.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-center" @click="sortData('table2','total_sales_amount')">
                  Total Sales Amount 
                  <span v-if="sortParams.table2.sortKey === 'total_sales_amount'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table2.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sale in sortedSalesData" :key="sale.id">
                <td class="text-center">{{ getKitType(sale.type) }}</td>
                <td class="text-center">{{ sale.year }}</td>
                <td>{{ sale.type }}</td>
                <td class="text-center">{{ sale.unit_count }}</td>
                <td class="text-center">{{ sale.order_count }}</td>
                <td class="text-right" style="min-width:100px">{{ formatPrice(sale.average_unit_price_amount) }}</td>
                <td class="text-right" style="min-width:150px">{{ formatPrice(sale.total_sales_amount) }}</td>
              </tr>
              <tr>
                <td class="text-center total"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right"><span class="total">Total</span> : {{ formatPrice(totalSalesAmount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="sales-data sales-data-woo" >
          <h1>Woo Sales</h1>
          <table class="sales-table styled-table">
            <thead>
              <tr>
                <th class="title-data text-center"  @click="sortData('table3','type')">
                  Type 
                  <span v-if="sortParams.table3.sortKey === 'type'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table3.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th  @click="sortData('table3','product_name')">
                  Name 
                  <span v-if="sortParams.table3.sortKey === 'product_name'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table3.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-right" @click="sortData('table3','total_quantity')">
                  Quantity
                  <span v-if="sortParams.table3.sortKey === 'total_quantity'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table3.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
                <th class="title-data text-right" @click="sortData('table3','total_sales_amount')">
                  Product Price
                  <span v-if="sortParams.table3.sortKey === 'total_sales_amount'">
                    <span class="sort-data date">
                        <img
                          class="img-sort"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-if="sortParams.table3.sortOrder === 'asc'"
                        />
                        <img
                          class="img-sort down"
                          src="../../images/dashboard/up.png"
                          alt="#"
                          v-else
                        />
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sale in sortedWooSalesData" :key="sale.id">
                <td class="text-center">{{ sale.type }}</td>
                <td >{{ sale.product_name }}</td>
                <td class="text-right">{{ sale.total_quantity }}</td>
                <td class="text-right">{{ formatPrice(sale.total_sales_amount) }}</td>
              </tr>
              <tr>
                <td class="text-center total"></td>
                <td></td>
                <td></td>
                <td class="text-right"><span class="total">Total</span> : {{ formatPrice(totalWooAmount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from "axios";
import moment from 'moment';
import VChart from 'vue-echarts';
import * as echarts from 'echarts';
import FilterDays from "./timeline/FilterDays.vue";

export default {
  name: 'FbaInventoryTable',
  components: {
    VChart,
    FilterDays,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      chartOptions: {
        totalSales: this.getChartOptions('Total Sales'),
        amazonSales: this.getChartOptions('Amazon Sales'),
        wooSales: this.getChartOptions('Woo Sales'),
      },
      showPieChart: false,
      sortParams: {
        table1: {
          sortKey: 'type',
          sortOrder: 'asc',
        },
        table2: {
          sortKey: 'type',
          sortOrder: 'asc',
        },
        table3: {
          sortKey: 'type',
          sortOrder: 'asc',
        }
      },
      total_sales_price:0,
      salesData: [],
      salesHistory: [],
      selectedPlatform: 'amazon',
      wooSalesData: [],
      lineOptions: {},
      showlinechart: false,
      chartType: 'pie',
      filters: {
        month: { value: 20, text: 'YTD' },
        year: ''
      },
      monthOptions: [
        { value: 22, text: 'Today' },
        { value: 23, text: 'This Week' },
        { value: 24, text: 'This Month' },
        { value: 13, text: '30 Days' },
        { value: 14, text: '60 Days' },
        { value: 15, text: '90 Days' },
        { value: 16, text: 'Q1' },
        { value: 17, text: 'Q2' },
        { value: 18, text: 'Q3' },
        { value: 19, text: 'Q4' },
        { value: 20, text: 'YTD' },
        { value: 21, text: 'All' },
        { value: 1, text: 'January' },
        { value: 2, text: 'February' },
        { value: 3, text: 'March' },
        { value: 4, text: 'April' },
        { value: 5, text: 'May' },
        { value: 6, text: 'June' },
        { value: 7, text: 'July' },
        { value: 8, text: 'August' },
        { value: 9, text: 'September' },
        { value: 10, text: 'October' },
        { value: 11, text: 'November' },
        { value: 12, text: 'December' }
      ],
      dayFilterMap: {
        13: 30,
        14: 60,
        15: 90,
        16: 1,
        17: 2,
        18: 3,
        19: 4,
        20: 5,
        21: 0,
        22: 30,
        23: 30,
        24: 30,
      },
      dayFilters : {
        30: "30 Days",
        60: "60 Days",
        90: "90 Days",
        1: "Q1",
        2: "Q2",
        3: "Q3",
        4: "Q4",
        5: "YTD",
        6: "Today",
        7: "This Week",
        0: "All"
      },
      step: 30,
      yearOptions: this.getYearOptions(),
      show: false,
      message:'',
      disabled: true
    };
  },
  computed: {
    ...mapGetters(['getAmazonFba','getFilterSalesdata','getDays','getFilterWooSalesdata']),
    isEmpty() {
      return !Array.isArray(this.getAmazonFba) || this.getAmazonFba.length === 0;
    },
    totalSalesData() {
      return this.aggregateTotalSalesData();
    },
    amazonSalesData() {
      return this.aggregateAmazonSalesData();
    },
    wooSalesDataComputed() {
      return this.aggregateWooSalesData();
    },
    sortedTotalSalesData() {
      const result = {};
      //Process sortedSalesData
      this.sortedSalesData.forEach(sale => {
        const type = this.getKitType(sale.type);
        if (!result[type]) {
          result[type] = {
            type: type,
            product_name: "N/A",  // Default or representative product name
            total_quantity: Number(sale.unit_count),
            total_sales_amount: parseFloat(sale.total_sales_amount)
          };
          
        }
      });

      // Process sortedWooSalesData
      this.sortedWooSalesData.forEach(sale => {
        const type = sale.type;
        if (result[type]) {
          result[type].product_name = sale.product_name;
          result[type].total_quantity += Number(sale.total_quantity);
          result[type].total_sales_amount += parseFloat(sale.total_sales_amount);
        }

      });
      this.total_sales_price = parseFloat(this.totalSalesAmount) + parseFloat(this.totalWooAmount) ;
      // Convert the result object to an array
      const resultArray = Object.values(result);

      // Sort the resultArray based on table1 sortKey and sortOrder
      if (resultArray.length > 0 && this.sortParams.table1.sortKey) {
        resultArray.sort((a, b) => {
          let valueA = a[this.sortParams.table1.sortKey];
          let valueB = b[this.sortParams.table1.sortKey];

          // Ensure numeric comparison for specific fields
          if ((this.sortParams.table1.sortKey === 'total_quantity' || this.sortParams.table1.sortKey === 'total_sales_amount') && !isNaN(valueA) && !isNaN(valueB)) {
            valueA = parseFloat(valueA);
            valueB = parseFloat(valueB);
          }

          let modifier = this.sortParams.table1.sortOrder === 'asc' ? 1 : -1;
          
          if (valueA > valueB) return 1 * modifier;
          if (valueA < valueB) return -1 * modifier;
          return 0;
        });
      }

      return resultArray;
    },
    sortedSalesData() {
      if (!Array.isArray(this.salesData)) {
          return []; // Ensure this always returns an array
      }
      if (Array.isArray(this.salesData) && this.salesData.length > 0) {
        return this.salesData.slice().sort((a, b) => {
          let valueA, valueB;

          // Handle sorting for specific columns like 'type' using getKitType()
          if (this.sortParams.table2.sortKey === 'type') {
            valueA = this.getKitType(a.type).toUpperCase();
            valueB = this.getKitType(b.type).toUpperCase();
          } else {
            // For other columns, directly compare the values
            valueA = a[this.sortParams.table3.sortKey];
            valueB = b[this.sortParams.table3.sortKey];
          }
          if ((this.sortParams.table2.sortKey === 'average_unit_price_amount' ||  this.sortParams.table2.sortKey === 'total_sales_amount' ) && !isNaN(valueA) && !isNaN(valueB)) {
            valueA = parseFloat(valueA);
            valueB = parseFloat(valueB);
          }
          let modifier = this.sortParams.table2.sortOrder === 'asc' ? 1 : -1;
          if (valueA > valueB) {
            return 1 * modifier;
          }
          if (valueA < valueB) {
            return -1 * modifier;
          }
          return 0;
        });
      } else {
        return this.salesData;
      }
    },
    sortedWooSalesData() {
        if (!Array.isArray(this.wooSalesData)) {
            return []; // Ensure this always returns an array
        }
        if (Array.isArray(this.wooSalesData) && this.wooSalesData.length > 0) {
          return this.wooSalesData.slice().sort((a, b) => {
            let valueA, valueB;

            // Handle sorting for specific columns like 'type' using getKitType()

            // For other columns, directly compare the values
            valueA = a[this.sortParams.table3.sortKey];
            valueB = b[this.sortParams.table3.sortKey];
            if ((this.sortParams.table3.sortKey === 'total_sales_amount') && !isNaN(valueA) && !isNaN(valueB)) {
              valueA = parseFloat(valueA);
              valueB = parseFloat(valueB);
            }
            let modifier = this.sortParams.table3.sortOrder === 'asc' ? 1 : -1;
            if (valueA > valueB) {
              return 1 * modifier;
            }
            if (valueA < valueB) {
              return -1 * modifier;
            }
            return 0;
          });
        } else {
          return this.wooSalesData;
        }
    },
    totalSalesAmount() {
      return this.sortedSalesData.reduce((total, sale) => {
        return total + parseFloat(sale.total_sales_amount);
      }, 0);
    },
    totalWooAmount() {
      return this.sortedWooSalesData.reduce((total, sale) => {
        return total + parseFloat(sale.total_sales_amount);
      }, 0);
    },
  },
  methods: {
    ...mapActions(['setDaysFilter','setYearFilter', 'setWooSalesData', 'setSalesSubData', 'setWooSalesSubData']),
    getChartOptions(title) {
      return {
        title: {
          text: title,
          subtext: 'Sales Distribution',
          left: '50%',
          textAlign: 'center',
          subtextAlign: 'center',
          bottom: '85%',
          textStyle: {
            fontFamily: "'TT Norms Medium', sans-serif",
            color: '#005EB8',
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            textRendering: "optimizeLegibility",
            fontWeight: 600,
          },
          subtextStyle: {
            color: '#98A4AE',
            fontSize: 14,
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
              const value = params.data.value;
              const name = params.data.name;
              return `${name}: $${value.toFixed(2)}`;
            },
        },
        legend: {
          orient: 'horizontal',
          bottom: '1%',
          left: '0%',
          itemGap: 12,
        },
        series: [
          {
            name: 'Sales',
            type: 'pie',
            center: ['50%', '55%'],
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            label: {
              show: true,
              formatter: '{b}: {d}%',
            },
          },
        ],
      };
    },
    getSalesOptions(title, Data) {
        const platforms = ['amazon', 'woo', 'total'];
        const categories = Object.keys(Data['salesData'][platforms[0]]);
        const isMonthly = Data.hasOwnProperty('month') && Data.month !== null;
        return {
          title: {
            text: title,
            subtext: isMonthly ? 'Daily Revenue and Units' : 'Monthly Revenue and Units',
            left: 'center',
            textStyle: {
              fontFamily: 'TTNormsBold, sans-serif',
              color: '#005EB8',
              fontSize: 18,
            },
            subtextStyle: {
              color: '#888',
              fontSize: 14,
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: (params) => {
              const platform = params.seriesName.toLowerCase();
              const month = params.name;
              const day = parseInt(params.name, 10);
              const year = Data.year;
              const salesData = Data['salesData'][platform][month];

              let displayDate;
              if (!isNaN(day)) {
                const monthNumber = Data.month;
                const monthName = this.getMonthName(monthNumber);
                displayDate = `${day}, ${monthName}, ${year}`;
              } else {
                const monthName = params.name;
                displayDate = `${monthName}, ${year}`;
              }

              let tooltipContent = `${platform.charAt(0).toUpperCase() + platform.slice(1) + ' Sales'}<br/>${displayDate}:<br/>`;

              if (salesData) {
                const total = salesData.total;
                const units = salesData.units;
                tooltipContent += `Total - $${total.toFixed(2)}<br/>Units Sold - ${units}<br/>`;

                if (salesData.types) {
                  const typesWithCount = Object.entries(salesData.types).filter(([type, count]) => count > 0);

                  if (typesWithCount.length > 0) {
                    tooltipContent += `Units by Type:<br/>`;
                    for (const [type, count] of typesWithCount) {
                      tooltipContent += `${type}: ${count}<br/>`;
                    }
                  }
                }
              } else {
                tooltipContent += `${platform.charAt(0).toUpperCase() + platform.slice(1)}<br/>${displayDate}: No data available`;
              }

              return tooltipContent;
            },
          },
          legend: {
            data: platforms.map(platform => platform.charAt(0).toUpperCase() + platform.slice(1)),
            bottom: '1%',
          },
          xAxis: {
            type: 'category',
            data: categories,
            boundaryGap: !isMonthly,
            axisLabel: {
              interval: 0,
              rotate: isMonthly ? 0 : 30,
            },
            name: isMonthly ? 'Day' : 'Month',
          },
          yAxis: {
            type: 'value',
            name: 'Sales ($)',
          },
          series: platforms.map(platform => ({
            name: platform.charAt(0).toUpperCase() + platform.slice(1),
            type: 'line',
            data: categories.map(month => {
              const salesData = Data['salesData'][platform][month];
              return salesData ? salesData.total : 0;
            }),
            smooth: true,
            itemStyle: {
              color: platform === 'amazon' ? '#005EB8' : platform === 'woo' ? '#c23531' : '#ffbf00',
            },
            symbolSize: 10,
          })),
        };
      },
    aggregateTotalSalesData() {
      const aggregatedData = {};
      const combinedSalesData = [
        ...this.sortedSalesData.map(sale => ({
          ...sale,
          type: this.getKitType(sale.type)
        })),
        ...this.sortedWooSalesData
      ];
      combinedSalesData.forEach(sale => {
        const type = sale.type || "Unknown";
        if (!aggregatedData[type]) {
          aggregatedData[type] = 0;
        }
        aggregatedData[type] += parseFloat(sale.total_sales_amount) || 0;
      });

      return Object.entries(aggregatedData).map(([key, value]) => ({
        name: key,
        value: value,
      }));
    },
    aggregateAmazonSalesData() {
      const aggregatedData = {};
      this.sortedSalesData.forEach(sale => {
        const type = sale.type ? this.getKitType(sale.type) : "Unknown";
        if (!aggregatedData[type]) {
          aggregatedData[type] = 0;
        }
        aggregatedData[type] += parseFloat(sale.total_sales_amount);
      });

      return Object.entries(aggregatedData).map(([key, value]) => ({
        name: key,
        value: value,
      }));
    },
    aggregateWooSalesData() {
      const aggregatedData = {};
      this.sortedWooSalesData.forEach(sale => {
        const type = sale.type || "Unknown";
        if (!aggregatedData[type]) {
          aggregatedData[type] = 0;
        }
        aggregatedData[type] += parseFloat(sale.total_sales_amount);
      });

      return Object.entries(aggregatedData).map(([key, value]) => ({
        name: key,
        value: value,
      }));
    },
    updatePieCharts() {
      const colors = ['#005EB8', '#43B02A', '#98A4AE', '#F1B434', '#AC75BD', '#00BBCD'];

      this.chartOptions.totalSales.series[0].data = this.sortPieData(this.totalSalesData, colors);
      this.chartOptions.amazonSales.series[0].data = this.sortPieData(this.amazonSalesData, colors);
      this.chartOptions.wooSales.series[0].data = this.sortPieData(this.wooSalesDataComputed, colors);

      // Check if there's data for any chart
      this.showPieChart = [
        this.chartOptions.totalSales.series[0].data,
        this.chartOptions.amazonSales.series[0].data,
        this.chartOptions.wooSales.series[0].data,
      ].some((data) => data.length > 0);
    },
    sortPieData(data, colors) {
      // Sort data by value in descending order
      const sortedData = [...data].sort((a, b) => b.value - a.value);

      // Map sorted data to include colors
      return sortedData.map((item, index) => ({
        value: item.value,
        name: item.name,
        itemStyle: {
          color: colors[index % colors.length], // Assign color based on sorted index
        },
      }));
    },
    updateChart() {
      const { month, year } = this.salesHistory;
      const title = month ? `Sales History (${this.getMonthName(month)}, ${year})` : `Sales History (${year})`;
      this.lineOptions = this.getSalesOptions(title, this.salesHistory);
    },
    reset(){
      this.filters.year = "";
      this.filters.month = 20;
      //this.setWooSalesData();
      //this.setSalesData();
      this.getSalesHistory();
      if (this.dayFilters[this.$store.getters.getDays]) {
        this.message = "Filter by " + this.dayFilters[this.$store.getters.getDays];
      }
    },
    sortData(table, key) {
      let params = this.sortParams[table];
      if (params.sortKey === key) {
        params.sortOrder = (params.sortOrder === 'asc') ? 'desc' : 'asc';
      } else {
        params.sortKey = key;
        params.sortOrder = 'asc'; // Reset to ascending when sorting a new column
      }
    },
    formattedDate(date) {
      // Format the date as 'MM/DD/YYYY' 
      return moment(date).format('MM/DD/YYYY');
    },
    getKitType(asin) {
      const kitTypes = {
        'B086D5RQ7N': 'F1',
        'B086D4464B': 'F2',
        'B086DCV9Q7': 'F3',
        'B0C7CXXSRH': 'R1',
        'B0C7D1RCQ4': 'R2',
        'B0C7D167SM': 'R3'
      };
      return kitTypes[asin] || 'Unknown'; // Default value if ASIN not found
    },
    getMonthName(monthNumber) {
      const month = this.monthOptions.find(m => m.value == monthNumber);
      return month ? month.text : '';
    },
    getYearOptions() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 2 }, (v, i) => currentYear - i); // Last 5 years including the current year
    },
    async fetchSalesData() {
      this.message = '';
      if(this.filters.year == '') {
        this.filters.year = new Date().getFullYear();
      }
      let data = {
          month: this.filters.month,
          year: this.filters.year,
      };
      if (this.filters.month > 12 || [0].includes(this.filters.month)) {
        if([13, 14, 15, 22, 23, 24, 20, 21, 0].includes(this.filters.month)) {
          //this.filters.year = '';
          //this.setYearFilter(this.filters.year);
          if([21].includes(this.filters.month)) {
            this.filters.year = ''
            this.setYearFilter(null);
            data = {
                     month: this.filters.month
                  };
          }
          this.disabled = true;
        } else {
          this.disabled = false;
        }
        const val = this.dayFilterMap[this.filters.month];
        await this.setDaysFilter(val);
        await this.setSalesSubData(data);
        await this.setWooSalesSubData(data);
        await this.getSalesHistory(data);
        return false;
      } else {
        await this.setSalesSubData(data);
        await this.setWooSalesSubData(data);
        await this.getSalesHistory(data);
        this.disabled = false;
      }      
    },
    async getSalesHistory(data) {
      let url = "/v1/admin/getSalesHistory?";
      if (data && data.year) {
        if(url == "/v1/admin/getSalesHistory?") {
          url += `year=${data.year}`;
        } else {
          url += `&year=${data.year}`;
        }
      }
      if (data && data.month) {
        if(url == "/v1/admin/getSalesHistory?") {
          url += `month=${data.month}`;
        } else {
          url += `&month=${data.month}`;
        }
      }
      try {
        const response = await axios.get(url);
        if (!response.data || Object.keys(response.data).length === 0) {
          console.log('No sales history data available.');
          this.showlinechart = false;
          return;
        }
        this.salesHistory = response.data;
        this.updateChart();
        this.showlinechart = true;
      } catch (error) {
        console.error('Error fetching sales history:', error);
      }
    },    
    formatPrice(value) {
      // Convert the input value to a number, if it's a string
      const numberValue = typeof value === "string" ? parseFloat(value) : value;
      
      if (isNaN(numberValue)) {
        return value; // Return the original value if it's not a valid number
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numberValue);
    },
    closeModelList() {
      this.show = false;
    }
  },
  watch: {
    'filters.year'(newYear) {
      let data = {
          year: newYear,
      };
      this.setYearFilter(newYear);
      this.getSalesHistory(data);
      //this.setWooSalesData();
      //this.setSalesData();
    },
    selectedPlatform: 'updateChart',
    salesData(newValue) {
      if (newValue) {
        this.updatePieCharts();
      }
    },
    wooSalesData(newValue) {
      if (newValue) {
        this.updatePieCharts();
      }
    },
    getDays(obj) {
      if (this.dayFilters[obj]) {
        this.message = "Filter by " + this.dayFilters[obj];
      } else {
        this.message = "";
      }
      
      // Clear year and month filters
      // this.filters.year = "";
    },
    getFilterSalesdata(obj) {
      const requiredTypes = [
        "B086D4464B",
        "B086DCV9Q7",
        "B086D5RQ7N",
        "B0C7D1RCQ4",
        "B0C7CXXSRH",
        "B0C7D167SM"
      ];

      if (obj.length > 0) {
        // Convert existing types into a Set for quick lookup
        const existingTypes = new Set(obj.map(item => item.type));

        // Add missing types with default values
        requiredTypes.forEach(type => {
          if (!existingTypes.has(type)) {
            obj.push({
              year: new Date().getFullYear(),
              month: new Date().getMonth() + 1,
              type,
              average_unit_price_amount: 0,
              total_sales_amount: 0,
              order_item_count: 0,
              order_count: 0,
              unit_count: 0
            });
          }
        });

        this.salesData = obj;
      } else {
        // If obj is empty, initialize with default values
        this.salesData = requiredTypes.map(type => ({
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          type,
          average_unit_price_amount: 0,
          total_sales_amount: 0,
          order_item_count: 0,
          order_count: 0,
          unit_count: 0
        }));
      }
    },
    getFilterWooSalesdata(obj) {
      const requiredTypes = [
        { type: "F1", product_name: "1-Room Kit" },
        { type: "F2", product_name: "2-Room Kit" },
        { type: "F3", product_name: "3-Room Kit" },
        { type: "R1", product_name: "1-Room Refill" },
        { type: "R2", product_name: "2-Room Refill" },
        { type: "R3", product_name: "3-Room Refill" }
      ];
      if (obj.length > 0) {
        // Convert array to a Set of existing types
        const existingTypes = new Set(obj.map(item => item.type));

        // Add missing types with default values
        requiredTypes.forEach(({ type, product_name }) => {
          if (!existingTypes.has(type)) {
            obj.push({
              month: new Date().getMonth() + 1,
              product_id: 0,
              product_name,
              total_quantity: 0,
              total_sales_amount: "0.00",
              type,
              year: new Date().getFullYear()
            });
          }
        });

        this.wooSalesData = obj;
      } else {
        // If obj is empty, initialize with default values
        this.wooSalesData = requiredTypes.map(({ type, product_name }) => ({
          month: new Date().getMonth() + 1,
          product_id: 0,
          product_name,
          total_quantity: 0,
          total_sales_amount: "0.00",
          type,
          year: new Date().getFullYear()
        }));
      }
    }
  },
  mounted() {
      // If the obj is a valid key in dayFilters
    if (this.dayFilters[this.$store.getters.getDays]) {
      this.message = "Filter by " + this.dayFilters[this.$store.getters.getDays];
    } else {
      this.message = "";
    }
    this.setYearFilter(this.filters.year)
    //this.filters.year = "";
    this.filters.month = 20;
    this.getSalesHistory();
    this.salesData = this.$store.getters.getFilterSalesdata;
    this.wooSalesData = this.$store.getters.getFilterWooSalesdata;
  }
};
</script>

<style scoped>
.chart-container {
  width: 100%; 
}

.chart-type-selector {
  display: flex;
  align-items: center;
  justify-content: start;
}

.chart-type-selector h2 {
  margin: 0;
  margin-left: 10px;
  padding-top: 0px !important;
  padding-right: 0px !important;
  width: 6rem;
}

.line-chart-wrap {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 10px 10px 25px 10px;
  display: flex;
  flex-direction: column;
}

.line {
  padding: 15px 5px 10px 5px;
}

.line-chart-wrap > .line {
  width: 100%;
}

.line-chart-wrap > .radio-wrap {
  width: 100%;
}

.line-chart-wrap > div > * {
  width: 100%;
}

.radio-span {
  margin-left: 12px;
}
.radio-span label{
  cursor: pointer;
}
.input-wrap input[type="radio"] {
  margin-right: 4px;
}

.pie-charts {
  margin: 10px 10px 25px 10px;
  background-color: transparent;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 0.5rem;
}

.pie-charts > div {
  width: 100%;
  height: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  background-color: #fff;
  max-width: 100%;
  overflow: hidden;
}

.pie-charts > div > * {
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.title_check {
  color: #005eb8;
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
}

.kits {
  margin: 15px 0;
}
.form, .sales-data {
  background-color: #fff;
  width: 100%;
  overflow-x: auto;
}
.form, .inv-data {
  background-color: #fff;
  width: 100%;

}
.inv-data-table {
  overflow-x: auto;
}

.editlog {
  padding-top: 20px;
}

.fba-table, .sales-table {
  width: 100%;
}
.fba-table td, .sales-table td {
  color: #000000;
}
.fba-table th, .sales-table th, .fba-table td, .sales-table td {
  padding: 0 0 0 8px;
  text-align: left;
}

.fba-table th, .sales-table th {
  background-color: #005eb8;
  color: #f5f7fa;
  font-family: TTNormsMedium, sans-serif;
}

.day-filter {
  display: flex;
  align-items: center;
}

.title-filter {
  color: #005eb8;
  font-size: 14px;
  font-weight: 500;
  font-family: TTNormsMedium, sans-serif;
  max-width: 125px;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid #e7ecef;
  border-radius: 5px;
  padding: 8px 15px;
}

.title-filter .filter-label {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
}

.title-down {
  height: 16px;
  cursor: pointer;
  vertical-align: top;
  font-weight: 500;
}

.drop-down-menu {
  margin: 0px 0px 0px 5px !important;
  font-weight: 500;
}

.day-list {
  left: unset;
}

.filters {
  display: flex;
  justify-content: flex-end;
  padding: 20px 10px;
  height: 4.5rem;
  margin-top: 15px;
}

.filters label {
  margin-right: 10px;
  font-family: TTNormsMedium, sans-serif;
  color: #b3b3b3;;;
}

.filters input {
  margin-right: 10px;
}

.filter-wrap-custom {
  display: flex;
  justify-content: flex-end;
  margin-left: 10px;
  width: 200px;
}
.filter-wrap-btn {
  display: inline-flex;
  justify-content: flex-end;
  margin-left: 10px;
}
.filter-list-wrap {
  position: absolute;
  right: 0px;
  top: 35px;
  width: 160px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 1px rgba(152, 164, 174, 0.4);
  z-index: 1;
}

.disabled {
  color: #98A4AE !important;
}

.no-data-message {
  color: red;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}
 h1 {
  font-family: TTNormsBold, sans-serif;
  color: #005EB8;
  text-align: center;
  font-size: 20px;

 }

 h2 {
  padding-top: 7px ;
  font-family: TTNormsBold, sans-serif;
  color: #005EB8;
  text-align: center;
  font-size: 15px;
  padding-right: 25px;
 }

 .input-filter {
  padding: 5px 10px;
  width: 100%;
  font-size: 16px;
  text-align: left;
  outline: none;
  border-radius: 5px;
  font-family: TTNormsRegular, sans-serif;
  background-color:#005eb8;
  color: #fff;
  border: 1px solid #005eb8;
  text-align-last: left;
}

.input-sub-filter {
  padding: 5px 10px;
  width: 100%;
  font-size: 16px;
  text-align: left;
  outline: none;
  border-radius: 5px;
  font-family: TTNormsMedium, sans-serif;
  background-color:#fff;
  color: #005eb8;
  border: 1px solid #cccccc;
  text-align-last: left;
}

.input-sub-filter option {
  font-family: TTNormsLight, sans-serif;
  background-color: #fff;
  color: #373737;
  border: 1px solid #fff;
}

.input-filter option {
  font-family: TTNormsLight, sans-serif;
  background-color: #fff;
  color: #373737;
  border: 1px solid #fff;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 100px;
  width: 100%;
}

.btn {
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 5px 15px 5px 15px;
  cursor: pointer;
  border-radius: 5px;
}

.search-input {
  font-size: 14px;
  font-weight: 500px;
  font-family: TTNormsMedium, sans-serif;
  background-color: #fff;
  outline: none;
  border-radius: 10px;
  transition: all 0.5s linear;
  margin-right: 10px;
  margin-left: 10px;
  border: 1px solid #cccccc;
  height: 20px;
  padding-top: 14px;
  padding-bottom: 14px;
}
.search-input::placeholder {
  color: #cccccc;
  font-family: TTNormsMedium, sans-serif;
  opacity: 0.8;
}
.search-input:focus {
  background-color: #e3e3e3;
}
.text-right{
text-align: right !important;
padding-right: 5px !important;
}
.text-center{
  text-align: center !important;
}
.postion-sticky {
  position: sticky;
  left: 0;
  background-color: #fff; /* Ensure the sticky column doesn't overlap with other content */
  z-index: 1; /* Ensure sticky column stays on top */
  width: 150px; /* Fixed width for the sticky column */
}

.fba-table th:first-child{
  background-color: #005eb8;
  color: #fff;
  position: sticky;   /* Sticky column */
  left: 0;
  z-index: 1; 

}
.fba-table td:first-child {
  background-color: #fff;  /* Light background for the first column */
  position: sticky;   /* Sticky column */
  left: 0;
  z-index: 1;  /* Ensure the first column stays on top */
}

/* Style for the rest of the columns (both header and body cells) */
.sales-data-woo{
    margin-top: 10px;
    margin-bottom: 10px;
}
.p-20 {
  padding-bottom: 20px;
}
.img-sort {
  width: 10px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.sales-data h1 {
  color: #005eb8;
  font-family: TTNormsMedium, sans-serif;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
.total{
  font-weight: bold;
  color: #005eb8;
}
.description-modal{
  text-align: end;
  position: absolute;
  top: 35px;
  left: 1px;
  z-index: 1;
  width: 100%;
}
</style>
